import moment from 'moment-timezone';
import { FONT_FAMILY } from '@utils/constants';
import { TOOLTIP_LABEL_FORMAT } from '@components/common/Charts/utils';
import humanizeValue from '@utils/humanizeUtil';
import { humanize } from '@utils';
import { getMetricUnitByKey, getMetricUnitText, getMetricOvbDisplayName } from '@utils/metrics';
import { query as originQuery } from '../metricsData/schema';
import { DEFAULT_FILTER_COLOR } from '@src/utils/colorPalette';

const createQuery = (metricName, interval, filter, granularity, kpiConfig) => {
  const query = {
    ...originQuery,
    interval,
    filter,
    granularity,
    metrics: metricName,
  };

  query.options.kpiConfig = kpiConfig;

  return {
    queries: [query],
  };
};

export const formatMetricDataForChart = ({
  chartData,
  metricKey,
  color = DEFAULT_FILTER_COLOR,
}) => {
  const tooltipFormatter = (params) => {
    const unit = getMetricUnitByKey({ metricKey });
    const value = params[0].data;
    const yVal = humanize(value[1], unit);
    const metricDisplayName = getMetricOvbDisplayName({ metricKey });
    const xVal = moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
    return `${xVal}<br/>${metricDisplayName} - <b>${yVal}${getMetricUnitText(unit)}</b>`;
  };

  const option: any = {
    _viewType: 'timeseries',
    color: [color],
    grid: {
      left: 5,
      bottom: 5,
      right: 5,
      top: 5,
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
      font: FONT_FAMILY,
    },
    xAxis: {
      type: 'time',
      show: false,
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: [
      {
        data: chartData,
        type: 'line',
        showSymbol: false,
        areaStyle: {
          opacity: 0.1,
          color,
        },
        lineStyle: {
          width: 1,
        },
      },
    ],
  };
  return option;
};

const formatResponse = (metricsData, filterColor, audienceMetrics) => {
  const formattedResponse = {} as any;
  try {
    if (metricsData.response != null) {
      const totals = metricsData.response[0].totals;
      const data = metricsData.response[0].data;

      audienceMetrics.forEach((metricKey) => {
        const rawValue = totals[metricKey] as number;
        const response = humanizeValue(rawValue, metricKey);
        formattedResponse[metricKey] = {};
        formattedResponse[metricKey].metricKey = metricKey;
        formattedResponse[metricKey].rawValue = rawValue;
        formattedResponse[metricKey].humanizedNumber = response.humanizedNumber;
        formattedResponse[metricKey].humanizedUnit = response.humanizedUnit;
        formattedResponse[metricKey].chartData = formatMetricDataForChart({
          chartData: data.map((eachItem) => [eachItem.timestamp, eachItem.results[metricKey]]),
          metricKey,
          color: filterColor,
        });
        formattedResponse[metricKey].displayName = getMetricOvbDisplayName({ metricKey });
      });
    }
  } catch (err) {
    // ignore
  }
  return formattedResponse;
};

export { createQuery, formatResponse };
